import ability from './ability'

export const canNavigate = to => to.matched.some(route => {
    let permiso=ability.can(route.meta.action || 'read', route.meta.resource)
    console.log('Permiso para==',route.meta.action,route.meta.resource,'=>',permiso);
    return permiso;
})

export const _ = undefined
